import React, { useMemo, useState } from "react";

import useCallCenterT from "../../hooks/useCallCenterT";
import { getCallCenterBaseUrl } from "../../service/CallCenterApi";
import { getStoredAccessToken } from "../../utils/authSession";
import { isCallingEnabled } from "../../utils/orgFeatures";

const buildPlaybackSrc = (callId, recordingUrl) => {
  if (!isCallingEnabled()) {
    return "";
  }
  const storedUrl = String(recordingUrl || "").trim();
  if (!storedUrl) {
    return "";
  }
  if (callId) {
    const token = getStoredAccessToken();
    const query = token ? `?access_token=${encodeURIComponent(token)}` : "";
    return `${getCallCenterBaseUrl()}api/calls/${callId}/recording/audio${query}`;
  }
  return storedUrl;
};

const CallRecordingPlayer = ({ callId = null, recordingUrl, className = "" }) => {
  const t = useCallCenterT();
  const [playbackFailed, setPlaybackFailed] = useState(false);
  const url = useMemo(() => buildPlaybackSrc(callId, recordingUrl), [callId, recordingUrl]);

  if (!url) return null;

  return (
    <div className={`space-y-1 ${className}`.trim()}>
      <div className="text-xs font-semibold text-gray-600">{t("ccListenRecording")}</div>
      <audio
        controls
        preload="none"
        src={url}
        className="w-full"
        onError={() => setPlaybackFailed(true)}
      />
      {playbackFailed ? (
        <p className="text-xs text-red-600">{t("ccRecordingPlaybackFailed")}</p>
      ) : null}
    </div>
  );
};

export default CallRecordingPlayer;
